export default "__VITE_ASSET__DNn7CJCj__"